module.exports = __webpack_public_path__ + "img/not-available.044039c4.svg";